<mat-dialog-content>
    <h2>Redefinir senha</h2> 
    <h3>Insira seu email associado à sua conta para receber um link de redefinição de senha.</h3>

    <form class="form" [formGroup]="model"  (ngSubmit)="post()" class="text-center">
        <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" type="email">
            @if (model.get('email')?.invalid) {
                <mat-error>Informe o seu e-mail cadastrado</mat-error>
            }
        </mat-form-field>
        <button type="submit" mat-flat-button class="btn-primary">
            @if (_isLoading === true) {
                <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
            }
            @else{
                Avançar
            }
        </button>
        <button type="button" mat-button class="button-back" (click)="openModalLogin()">Voltar</button>
    </form>

</mat-dialog-content>